import Service from "../../services";

const orderModule = {
  namespaced: true,
  state: {
    list: [],
    filter: [],
    testOrder: [],
    order: [],
    readOnly: null,
    receiveFilter: {
      page_no: "1",
      direction: null,
      hospital: null,
      owner_name: null,
      pet_name: null,
      hn: null,
      dateOne: "",
      dateTwo: "",
      status_id: [1, 6],
      receive: false,
      daily_number: "",
      hasDailyNumer: true,
      is_out_lab: ["outLab", "inLab", "null"],
      test_Type: [],
      test_name: "",
    },
    resultFilter: {
      page_no: "1",
      direction: null,
      hospital: null,
      owner_name: null,
      pet_name: null,
      hn: null,
      dateOne: "",
      dateTwo: "",
      status_id: [2, 3, 4, 5, 6, 7, 8],
      receive: true,
      daily_number: "",
      ln: "",
      test_name: "",
      test_Type: [],
      is_out_lab: ["outLab", "inLab", "null"],
    },
    reportFilter: {
      page_no: "1",
      direction: null,
      hospital: null,
      owner_name: null,
      pet_name: null,
      hn: null,
      dateOne: "",
      dateTwo: "",
      dateRange: [],
      status_id: [4, 5],
      receive: true,
      daily_number: "",
      includingApprove: true,
      is_printed: ["print", "notPrint"],
      is_shared: ["shared", "notShared"],
      is_out_lab: ["outLab", "inLab", "null"],
      test_Type: [],
      test_name: "",
      page_type: "report",
    },
  },
  mutations: {
    SET_REPORT_FILTER: (state, data) => {
      state.reportFilter = data;
    },
    SET_RECEIVE_FILTER: (state, data) => {
      state.receiveFilter = data;
    },
    SET_ALL: (state, data) => {
      state.list = data;
    },
    SET_TEST_ORDER: (state, data) => {
      state.testOrder = data;
    },
    SET_ORDER: (state, data) => {
      state.order = data;
    },
    FILTER_ORDER: (state, data) => {
      state.filter = data;
    },
    SET_READ_ONLY: (state, data) => {
      state.readOnly = data;
    },
    SET_RESULT_FILTER: (state, data) => {
      state.resultFilter = data;
    },
  },
  actions: {
    resetFilter({ commit }) {
      commit("FILTER_ORDER", []);
    },
    setReportFilter({ commit }, data) {
      commit("SET_REPORT_FILTER", data);
    },
    setReceiveFilter({ commit }, data) {
      commit("SET_RECEIVE_FILTER", data);
    },
    setResultFilter({ commit }, data) {
      commit("SET_RESULT_FILTER", data);
    },
    setReadOnly({ commit }, boolean) {
      commit("SET_READ_ONLY", boolean);
    },
    setAll({ commit }) {
      // return Service.order.getAllOrder().then(res => {
      //     commit("SET_ALL", res);
      // });
    },
    setOrder({ commit }, payload) {
      return Service.order.getOrder(payload).then((res) => {
        commit("SET_ORDER", res);
      });
    },
    saveOrder({ commit }, payload) {
      return Service.order.saveOrder(payload);
      // .then((res)=>
      // commit("SET_ALL", res);
      // Service.order
      // .getTestOrder()
      // .then(res => commit("SET_TEST_ORDER", res))
      // );
    },
    setAllTestOrder({ commit }) {
      return Service.order
        .getTestOrder()
        .then((res) => commit("SET_TEST_ORDER", res));
    },
    filterData: async (context, payload) => {
      let res = await Service.order.filterOrder(payload);
      context.commit("FILTER_ORDER", res);
    },
    updateOrder({ commit, state }, payload) {
      const filter = {
        page_no: "1",
        direction: null,
        hospital: null,
        owner_name: null,
        pet_name: null,
        hn: null,
        start_date: "",
        end_date: "",
        status_id: [1, 6],
        receive: null,
        daily_number: "",
        test_name: "",
      };
      return Service.order.updateOrder(payload.id, payload);
      // .then((res) =>
      //     Service.order.filterOrder(filter).then(res => {
      //         commit("FILTER_ORDER", res);
      //     })
      // );
    },
    async reportOrder(Object, data) {
      let confirmPassword = await Service.auth.confirmPassword(data.payload);

      if (confirmPassword.confirm_password) {
        let token = confirmPassword.token;
        return await Service.order.reportOrder(data.ln, token);
      } else {
        return false;
      }
    },
    async rejectOrder(Object, data) {
      let confirmPassword = await Service.auth.confirmPassword(
        data.payloadConfirmPassword
      );

      if (confirmPassword.confirm_password) {
        let token = confirmPassword.token;
        return await Service.order.rejectOrder(
          data.ln,
          token,
          data.payloadRejectOrder
        );
      } else {
        return false;
      }
    },
    async approveOrder(Object, data) {
      let confirmPassword = await Service.auth.confirmPassword(data.payload);

      if (confirmPassword.confirm_password) {
        let token = confirmPassword.token;
        return await Service.order.approveOrder(data.ln, token);
      } else {
        return false;
      }
    },
    async sharedReport({ commit }, data) {
      return await Service.order.sharedReport(data.id, data.payload);
    },
    async countPrinted({ commit }, id) {
      return await Service.order.countPrinted(id);
    },

    // getOrderHistory(ln, status) {
    //     return Service.order.getOrderHistory(ln, status).then((dataHistory) => {
    //
    //     });
    // }
    async checkPermission({ commit }, data) {
      return await Service.permission.checkPermission(data.type, data.mod);
    },
    async getApproverOrderByHospital({ commit }, id) {
      return await Service.order.getApproverOrderByHospital(id);
    },
    async deleteReport({ commit }, id) {
      return await Service.order.deleteReport(id);
    },
    async updateLabType({ commit }, data) {
      return await Service.order.updateLabType(data.id, data.payload);
    },
    async setMultiReceive({ commit }, data) {
      return await Service.order.setMultiReceive(data);
    },
    async getOrderDetail({ commit }, id) {
      return await Service.order.getOrderDetail(id);
    },
  },
  getters: {
    getAll(state) {
      return state.list;
    },
    getTestOrder(state) {
      return state.testOrder;
    },
    getOrder(state) {
      return state.order;
    },
    getDataFromFilter(state) {
      return state.filter;
    },
    getReadOnly(state) {
      return state.readOnly;
    },
    getReceiveFilter(state) {
      return state.receiveFilter;
    },
    getResultFilter(state) {
      return state.resultFilter;
    },
    getReportFilter(state) {
      return state.reportFilter;
    },
  },
};
export default orderModule;
